/* OVO Partner Program - landingi dealerskie na q-boo.com (AIOS, 06.10.2026).
   Tracking: Meta Pixel (fbq) + GA4 (gtag) + dataLayer, po zgodzie z banera HubSpot. Konfiguracja w window.OVO_DEALER (layout).
   Konwersja glowna: Lead (wyslanie formularza, eventID wspolny z CAPI w workerze).
   Mikrokonwersje (Meta trackCustom / GA4 snake_case):
     FormStart, FormAbandon, CheckRegionClick, BecomePartnerClick, TechcardDownload, ModelDownload,
     ProductSelect {model}, BottomCTAClick {label}, ScrollDepth {percent: 50|75|90}
   Wersje jezykowe (08.10.2026): jezyk z <html lang>, teksty przycisku z data-* formularza (data-sending/data-done/data-btn).
   Klik trackowany przez atrybuty: data-ev="NazwaZdarzenia" data-loc="nav|hero|..." data-model="GS" data-label="...". */
(function () {
  var C = window.OVO_DEALER || {};
  var PAGE = C.page || location.pathname;
  var on = { meta: false, ga: false }, history = [];

  function snake(n) { return n.replace(/([a-z])([A-Z])/g, '$1_$2').replace(/([A-Z]+)([A-Z][a-z])/g, '$1_$2').toLowerCase(); }

  // --- tagi ladowane dopiero po zgodzie z banera cookies HubSpot (q-boo):
  //     Meta = kategoria "advertisement", GA4 = "analytics". Zdarzenia sprzed zgody sa odtwarzane po jej udzieleniu. ---
  function loadMeta() {
    if (on.meta || !C.pixel) return;
    on.meta = true;
    !function (f, b, e, v, n, t, s) { if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments) }; if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = []; t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s) }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', C.pixel);
    fbq('track', 'PageView');
    history.forEach(function (a) { toMeta.apply(null, a); });
  }
  function loadGA() {
    if (on.ga || !C.ga4) return;
    on.ga = true;
    var g = document.createElement('script'); g.async = true;
    g.src = 'https://www.googletagmanager.com/gtag/js?id=' + C.ga4;
    document.head.appendChild(g);
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { dataLayer.push(arguments); };
    gtag('js', new Date());
    // page_view wysyla juz aplikacja Google w Shopify - tu tylko zdarzenia
    gtag('config', C.ga4, { send_page_view: false });
    history.forEach(function (a) { toGA.apply(null, a); });
  }

  function toMeta(name, params, opts) {
    if (name === 'Lead') fbq('track', 'Lead', params, opts && opts.eventID ? { eventID: opts.eventID } : undefined);
    else fbq('trackCustom', name, params);
  }
  function toGA(name, params) { gtag('event', name === 'Lead' ? 'generate_lead' : snake(name), params); }

  function track(name, params, opts) {
    params = Object.assign({ page: PAGE }, params || {});
    history.push([name, params, opts]);
    if (on.meta) toMeta(name, params, opts);
    if (on.ga) toGA(name, params);
    window.dataLayer = window.dataLayer || [];
    dataLayer.push(Object.assign({ event: 'ovo_' + snake(name) }, params));
  }
  window.ovoTrack = track;

  window._hsp = window._hsp || [];
  window._hsp.push(['addPrivacyConsentListener', function (c) {
    var cat = (c && c.categories) || {};
    if (c && (c.allowed || cat.advertisement)) loadMeta();
    if (c && (c.allowed || cat.analytics)) loadGA();
  }]);

  // --- UTM: zapamietane z pierwszego wejscia w sesji (produkt -> landing glowny gubi query) ---
  var utm = {};
  try {
    var q = new URLSearchParams(location.search);
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid'].forEach(function (k) { if (q.get(k)) utm[k] = q.get(k); });
    if (Object.keys(utm).length) sessionStorage.setItem('ovo_utm', JSON.stringify(utm));
    else utm = JSON.parse(sessionStorage.getItem('ovo_utm') || '{}');
  } catch (e) {}

  // --- kliki z data-ev ---
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[data-ev]');
    if (!el) return;
    var p = {};
    if (el.dataset.loc) p.location = el.dataset.loc;
    if (el.dataset.model) p.model = el.dataset.model;
    if (el.dataset.label) p.label = el.dataset.label;
    track(el.dataset.ev, p);
  }, true);

  // --- scroll depth 50/75/90 ---
  var marks = [50, 75, 90], done = {}, tick = false;
  function onScroll() {
    tick = false;
    var h = document.documentElement, max = h.scrollHeight - h.clientHeight;
    if (max <= 0) return;
    var pct = (h.scrollTop || document.body.scrollTop) / max * 100;
    marks.forEach(function (m) { if (pct >= m && !done[m]) { done[m] = 1; track('ScrollDepth', { percent: m }); } });
  }
  window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(onScroll); } }, { passive: true });

  // --- formularz (landing glowny) ---
  function cookie(n) { var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : ''; }
  function initForm() {
    var form = document.getElementById('partnerForm');
    if (!form || !C.endpoint) return;
    var started = false, submitted = false, abandoned = false;
    function start() { if (!started) { started = true; track('FormStart'); } }
    form.addEventListener('focusin', start);
    form.addEventListener('input', start);
    function abandon() {
      if (started && !submitted && !abandoned) {
        abandoned = true;
        var filled = Array.prototype.filter.call(form.elements, function (x) { return x.name && x.value && x.type !== 'checkbox'; }).length;
        track('FormAbandon', { fields_filled: filled });
      }
    }
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') abandon(); });
    window.addEventListener('pagehide', abandon);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var b = form.querySelector('button[type=submit]'), err = form.querySelector('.formError');
      var L = document.documentElement.lang || 'en', d = form.dataset;
      var f = form.elements, eventID = 'ovoqb-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);
      var body = {
        source: 'qboo', icp: 'qboo-landing', lang: L, hutk: cookie('hubspotutk'),
        consent: !!form.querySelector('input[type=checkbox]:checked'),
        imie: f.name.value, firma: f.company.value, email: f.email.value, telefon: f.phone.value,
        miasto: f.region.value, showroom: f.showroom.value, message: f.message ? f.message.value : '', url: location.href.split('#')[0],
        utm_source: utm.utm_source || '', utm_medium: utm.utm_medium || '', utm_campaign: utm.utm_campaign || '',
        utm_content: utm.utm_content || '', utm_term: utm.utm_term || '',
        event_id: eventID, fbp: cookie('_fbp'), fbc: cookie('_fbc') || (utm.fbclid ? 'fb.1.' + Date.now() + '.' + utm.fbclid : '')
      };
      b.disabled = true; b.textContent = d.sending || 'SENDING...'; if (err) err.style.display = 'none';
      fetch(C.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (!j.ok) throw new Error('not ok');
          submitted = true;
          track('Lead', { content_name: 'ovo-partner-program', lang: L }, { eventID: eventID });
          document.getElementById('success').style.display = 'block';
          b.textContent = d.done || 'REQUEST RECEIVED ✓';
        })
        .catch(function () {
          b.disabled = false; b.textContent = d.btn || 'CHECK MY REGION →';
          if (err) err.style.display = 'block';
        });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initForm); else initForm();
})();
